// Importacion de css
import "../../../theme/tiposJuegos.css";
import styles from "../../../theme/programas/jugador.module.css";
import estiloJuegos from "../../../theme/Juegos.module.css";

import React, { useEffect, useRef, useState } from 'react';
import { Timestamp } from 'firebase/firestore';
import { useParams } from 'react-router-dom';

import { nomProgMemNombres, nomProgMemPalabras, nomProgParejas, nomProgSuperCerebrosDice } from "../../../datos/nombresBD";
import { useDato } from "../../../modelos/auth";
import { Ranking } from "../../../modelos/Sala";
import { Aplicacion } from "../../../modelos/usuario";
import { terminadoJuego, changePuntaje, addIntegrante, cleanJuego, resincronizarJuego } from "../../../redux/juegoSimultaneo/reducerJuegoSimultaneo";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { useSala } from "../../../repositorio/controlador/useSala";
import Loading from "../../components/Loading";
import JuegoSumas from "../rutasPrivadasMy/juegos/pages/calculo/JuegoSumas";
import JuegoSuperCerebrosDice from "../rutasPrivadasMy/juegos/pages/memoria/JuegoSuperCerebrosDice";
import JuegoMemoriaNombres from "../rutasPrivadasMy/juegos/pages/memoria/MemoriaNombres";
import JuegoMemoriaPalabras from "../rutasPrivadasMy/juegos/pages/memoria/MemoriaPalabras";
import JuegoDeMemoriaParejas from "../rutasPrivadasMy/juegos/pages/memoria/MemoriaParejas";

const WHATSAPP_URL_NEUROBICS = "https://api.whatsapp.com/send/?phone=573144030324&text=Quiero%20acceder%20a%20los%20Neurobics%20de%20SuperCerebros";

const IndicadorEspera = () => {
  return (
    <p className={styles.indicadorEspera}>
      <span>●</span>
      <span>&nbsp;&nbsp;&nbsp;●&nbsp;&nbsp;&nbsp;</span>
      <span>●</span>
    </p>
  )
}

const PlayerComponent = ({reboot,setReboot}:{reboot:boolean,setReboot:React.Dispatch<React.SetStateAction<boolean>>}) => {
  const idSala = useRef(useParams().idSala);

  const dispatch = useAppDispatch();
  const redux_nombre = useAppSelector((state) => state.juegoSimultaneo.nombre)
  const redux_telefono = useAppSelector((state) => state.juegoSimultaneo.telefono)
  const redux_sala = useAppSelector((state) => state.juegoSimultaneo.sala)
  const verPuntaje = useAppSelector((state) => state.juegoSimultaneo.verPuntaje)
  const finalizoJuego = useAppSelector((state) => state.juegoSimultaneo.finalizado)
  const ultimoResultadoRedux = useAppSelector((state) => state.juegoSimultaneo.ultimoResultado)
  const totalRedux = useAppSelector((state) => state.juegoSimultaneo.total)
  const loggedIn = useAppSelector(state => state.auth.loggedIn);

  const state = useDato().state as Aplicacion;

  const superCerebroImg: {src:string, style:React.CSSProperties}[] = [
    {src:"/assets/images/supercerebro/sc_SenalandoCerebro.png",style:{ margin: "0 0 0 -60%", width: "230%" }},
    {src:"/assets/images/supercerebro/sc_nice2.png",style:{ width: "90%", margin: "5% 0 0 6%" }},
    {src:"/assets/images/supercerebro/sc_emocion.png",style:{width: "97%", margin: "5% 0 0 4.4%"}}
  ];

  const [loading, setLoading] = useState(false);
  const [imagenEspera, setImagenEspera] = useState(0);

  const [data, setData] = useState(null)

  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');

  const [sala, setSala] = useState(idSala.current ?? "");

  const [etapa, setEtapa] = useState(1);

  const [indexJuego, setIndexJuego] = useState(0);

  const [rank, setRank] = useState<Ranking[]>([]);
  const [posicion, setPosicion] = useState<number>(-1);

  // unsubscribe del documento de la sala: en ref para que la limpieza al
  // desmontar use siempre la funcion vigente.
  const unsubSalaRef = useRef<(() => void) | null>(null);
  // Si el jugador reingresa, aqui queda el indice del ultimo juego que ya
  // completo, para no volver a lanzarselo.
  const indiceJugadoRef = useRef<number | null>(null);
  // Ultimo valor de "iniciar" ya procesado: evita que un snapshot repetido
  // (por ejemplo al reconectarse la red) reinicie el juego en curso.
  const prevIniciarRef = useRef(0);

  const {
    nuevoJugador,
    subscribirDoc,
    SubirResultados,
    TraerRankings,
    TraerResultado
  } = useSala();

  const DetenerSala = () => {
    if(unsubSalaRef.current){
      unsubSalaRef.current();
      unsubSalaRef.current = null;
    }
  }

  const EncontrarPosición = (ranking: Ranking[], telefonoJugador: string) => {
    if(!ranking) return -1;
    for (let i = 0; i < ranking.length; i++){
      if(ranking[i].telefono === telefonoJugador){
        return i;
      }
    }
    return -1;
  }

  const NullNumberDisplay = (n: number) => {
    if(n === null || n === undefined) return null;
    return Math.round(n);
  }

  const HandleAgregarJugador = async(nombreInput:string,telefonoInput:string,salaInput:string) => {
    // El teclado del celular suele agregar espacios; el telefono y la sala
    // hacen parte de rutas en Firestore y deben ir limpios.
    const nombre = (nombreInput ?? '').trim();
    const telefono = (telefonoInput ?? '').trim();
    const sala = (salaInput ?? '').trim();

    if(nombre === '' || telefono === '' || sala === ''){
      alert('complete todos los campos');
      return;
    }

    setNombre(nombre)
    setTelefono(telefono)
    setSala(sala)

    dispatch(terminadoJuego({ultimoResultado:0,tiempo:0,finalizado:false}))
    dispatch(changePuntaje({verPuntaje:false}))

    setLoading(true)
    prevIniciarRef.current = 0;
    const resultado = await nuevoJugador(sala,telefono,nombre)
    if(resultado === 'ok'){
      // Si ya habia jugado en esta sala (reingreso), recuperar su avance.
      const integrante = await TraerResultado(telefono,sala)
      if(integrante !== null){
        dispatch(resincronizarJuego({
          ultimoResultado: integrante.ultimoResultado ?? 0,
          total: integrante.total ?? 0,
          tiempo: 0,
          finalizado: false,
        }))
        indiceJugadoRef.current = integrante.indiceJuego ?? null;
        setNombre(integrante.nombre)
        dispatch(addIntegrante({nombre:integrante.nombre,telefono,sala}))
      }else{
        indiceJugadoRef.current = null;
        dispatch(addIntegrante({nombre,telefono,sala}))
      }
      DetenerSala()
      unsubSalaRef.current = subscribirDoc('juegos_linea/'+sala,setData)
      setEtapa(2)
      setLoading(false)
    }else{
      setLoading(false)
      if(resultado === 'no_existe'){
        alert('No existe la sala. Verifica el codigo con el host.')
      }else if(resultado === 'cerrada'){
        alert('El torneo ya inicio y no estabas registrado. Pide al host que te incluya en el proximo juego.')
      }else{
        alert('No se pudo conectar con la sala. Revisa tu conexion a internet e intenta de nuevo.')
      }
    }
  }

  const HandlerSubirResultados = async () => {
    const ok = await SubirResultados(totalRedux,ultimoResultadoRedux,Timestamp.now(),nombre,telefono,sala,indexJuego)
    if(!ok){
      alert('No se pudo enviar tu resultado. Revisa tu conexion a internet.')
    }
  }

  const LlamarJuego = (juego:string[]):JSX.Element => {
    switch (juego[indexJuego - 1]){
      case nomProgMemNombres:
        return <JuegoMemoriaNombres/>

      case nomProgMemPalabras:
        return <JuegoMemoriaPalabras/>

      case nomProgParejas:
        return <JuegoDeMemoriaParejas/>

      case nomProgSuperCerebrosDice:
        return <JuegoSuperCerebrosDice/>

      default:
        return <JuegoSumas/>
    }
  }

  useEffect(() => {
    if(etapa === 1){

      DetenerSala()

      setNombre('')
      setTelefono('')
      setIndexJuego(0)
      indiceJugadoRef.current = null;
      prevIniciarRef.current = 0;

      if(loggedIn){
        setNombre(state.nombres ?? '');
        setTelefono(state.telefono ?? '');
      }

      dispatch(cleanJuego())

      if(reboot){
        if(redux_nombre && redux_telefono && redux_sala){
          HandleAgregarJugador(redux_nombre,redux_telefono,redux_sala)
          setNombre(redux_nombre)
          setTelefono(redux_telefono)
          setSala(redux_sala)
        }
        setReboot(false)
      }

    }
    if(etapa === 1 || etapa === 3){
      let nuevaImagen = imagenEspera;

      while(nuevaImagen === imagenEspera){
        nuevaImagen = Math.floor(Math.random() * superCerebroImg.length);
      }

      setImagenEspera(nuevaImagen);
    }
    if(etapa === 5){
      DetenerSala()
      // El ranking final se consulta una sola vez: mucho mas barato que
      // mantener a todos los jugadores suscritos al ranking completo.
      TraerRankings(sala).then((res) => {
        setRank(res)
        setPosicion(EncontrarPosición(res, telefono));
      }).catch((e) => {
        console.error("Error trayendo el ranking final:", e)
      })
    }
  }, [etapa])

  useEffect(() => {
    if(!data){
      // El host borro la sala: pasar a la pantalla de posicion final.
      if(etapa > 1) setEtapa(5)
      return;
    }
    if(!data.iniciar) return; // Sala creada pero el torneo aun no comienza.
    if(data.iniciar === prevIniciarRef.current) return; // Snapshot repetido: ya se proceso este juego.
    prevIniciarRef.current = data.iniciar;

    setIndexJuego(data.iniciar)

    if(indiceJugadoRef.current === data.iniciar){
      // Reingreso: este juego ya lo completo, mostrar su puntaje y esperar.
      indiceJugadoRef.current = null;
      dispatch(changePuntaje({verPuntaje:true}))
      setEtapa(4)
      setLoading(false)
    }else{
      // Juego nuevo: limpiar el resultado anterior (el total se conserva) y jugar.
      indiceJugadoRef.current = null;
      dispatch(terminadoJuego({ultimoResultado:0,tiempo:0,finalizado:false}))
      dispatch(changePuntaje({verPuntaje:false}))
      setEtapa(3)
      setLoading(false)
    }
  }, [data])

  // El juego avisa que el jugador quiere ver su puntaje: pasar a la pantalla
  // de espera. (Antes esto se hacia con setState dentro del render.)
  useEffect(() => {
    if(verPuntaje === true && etapa === 3){
      setEtapa(4)
      setLoading(false)
    }
  }, [verPuntaje])

  useEffect(() => {
    if(finalizoJuego === true){
      HandlerSubirResultados()
    }
  }, [finalizoJuego])

  useEffect(() => {
    if(reboot){
      if(etapa === 1){
        // Ya esta en registro: reconectar directo si hay datos guardados.
        if(redux_nombre && redux_telefono && redux_sala){
          HandleAgregarJugador(redux_nombre,redux_telefono,redux_sala)
        }
        setReboot(false)
      }else{
        setEtapa(1)
      }
    }
  }, [reboot])

  // Limpieza unica al desmontar el componente.
  useEffect(() => {
    return () => {
      DetenerSala()
    }
  }, [])

  return (
    <div className={styles.contenedor}>
      <Loading isOpen={loading}></Loading>
      { etapa === 1 &&
        <>
          <p className={styles.titulo}>REGISTRO</p>
          <p className={styles.subtitulo}>¿Listo para demostrar que eres el mejor en nuestro super torneo?</p>
          <form className={styles.datosForm}>

            <div>
              <label htmlFor='name'>&nbsp; Nombre completo</label>
              <div>
                <input value={nombre} id='name' onChange={(event) => {setNombre(event.target.value)}} placeholder='NOMBRE'></input>
              </div>
            </div>

            <div>
              <label htmlFor='phone'>&nbsp; Numero de Telefono</label>
              <div>
                <input value={telefono} type='number' id='phone' onChange={(event) => {setTelefono(event.target.value)}} placeholder='TELEFONO: xxxxxxxxxx'></input>
              </div>
            </div>

            <div>
              <label htmlFor='room'>&nbsp; Sala</label>
              <div>
                <input value={sala} id='room' onChange={(event) => {setSala(event.target.value)}} placeholder='CODIGO SALA'></input>
              </div>
            </div>
          </form>
          <button className={`${styles.datosBoton} ${estiloJuegos.buttonEmpezar}`} onClick={() => HandleAgregarJugador(nombre,telefono,sala)}>Entrar a Sala</button>
      </>}

      { (etapa === 2 || etapa === 4) &&
      <>
        {etapa === 4 &&
          <div className={styles.infoEspera}>
          <p className={styles.puntajeEspera}>TU PUNTAJE FUE DE: <br/> <span>{NullNumberDisplay(ultimoResultadoRedux)} PUNTOS</span></p>
          <p className={styles.totalEspera}>TIENES EN TOTAL: <br/> <span>{NullNumberDisplay(totalRedux)} PUNTOS</span></p>
          </div>
        }
        <p className={styles.mensajeEspera}>{etapa === 2?<>ESPERANDO QUE EL <span>HOST</span> INICIE EL TORNEO...</>:"ESPERANDO EL SIGUIENTE JUEGO..."}</p>
        <div className={styles.imagenEspera} style={etapa === 4? {margin: "0 auto 3svh"}: {}}>
          <img src={superCerebroImg[imagenEspera].src} style={superCerebroImg[imagenEspera].style} alt='supercerebro'></img>
        </div>
        <IndicadorEspera/>
        <div style={{margin: (etapa === 2? "6svh": "1svh")}}></div>
      </>
      }

      { etapa === 3 && indexJuego >= 1 &&
      <div style={{flex:'1', height: "95%"}}>
        {data?.iniciar &&
          LlamarJuego(data?.juego)
        }
      </div>
      }
      { etapa === 5 &&
        <>
        <p className={styles.tituloEsperaRanking} style={{opacity: 0.4}}>TU RANKING</p>
        {(rank.length < 1)?
          <IndicadorEspera/>
          :
          <div className={styles.finalRanking}>
            FUISTE
            <div className={styles.finalPosicion}>
              <div>
                <div>#{posicion >= 0 ? posicion + 1 : '-'}</div>
              </div>
            </div>
            OBTUVISTE
            <div className={styles.finalIntegrantes}>
              {Math.round(totalRedux)}
            </div>
            PUNTO{Math.round(totalRedux) != 1 && "S"}
          </div>
        }
        <a
          className={`${styles.datosBoton} ${estiloJuegos.buttonEmpezar}`}
          href={WHATSAPP_URL_NEUROBICS}
          target="_blank"
          rel="noopener noreferrer"
        >NEUROBICS</a>
        </>
      }
    </div>
  )
}

export default PlayerComponent
